import { getSession, getLocalforage } from '@/common/js/api'
import { isArray, deepCopy, isEmpty, trim, getByteLen } from '@/common/js/utils'

export default {
  computed: {},
  methods: {
    async getData() {
      // const creativeData = getSession('creative_params_back') || []
      let creativeData = []
      try {
        creativeData = await getLocalforage('creative_params_back')
      } catch (e) {
        console.log('get local creative info error output: ', e)
      }
      if (isArray(creativeData) && creativeData.length) {
        // 有草稿创意
        this.creativeData = creativeData
      } else this.appendIdea() // 增加一个创意
      this.setIdea(0)
      this.show = true
    },
    selectSticker([idx, index]) {
      const { template } = this.formItem.creatives[0]
      const { max_length } = template[idx].restriction
      const item = template[idx].children[index]
      const len = template[idx].children.filter((ret) => ret.check).length
      const childLen = template[3].children.length
      if (!childLen) {
        // 增加封面广告语
        const { origin_template } = template[3].restriction
        this.pushCreative({ item: deepCopy(origin_template), index: 3 })
      }
      if (item.check && len === 1) this.$set(template[3], 'children', []) // 清除封面广告语
      if ((!item.check && len < max_length) || item.check) this.$set(item, 'check', !item.check)
    },
    delCreative([idx, index]) {
      const { template } = this.formItem.creatives[0]
      template[idx].children.splice(index, 1)
    },
    pushCreative({ item, index }) {
      const { template } = this.formItem.creatives[0]
      template[index].children.push(deepCopy(item))
    },
    replaceCreative({ item, index, idx }) {
      const { template } = this.formItem.creatives[0]
      template[index].children.splice(idx, 1, deepCopy(item))
    },
    // 添加自定义创意
    spliceCreative(param) {
      let { id, type, mode, data } = param
      if (mode === 1) mode = 'vertical'
      else if (mode === 2) mode = 'video'
      else if (mode === 3) mode = 'image'
      if (type === 'add') {
        const material = this.formItem.creativeElements[mode]
        const item = deepCopy(this.formItem.creatives).pop()
        const df_id = item ? item.id : 0
        data.forEach((ret, id) => {
          const mater = deepCopy(material)
          const sourceVideo = {
            photo_id: ret.id,
            url: ret.url,
            width: ret.width,
            height: ret.height,
            file_size: ret.size,
            type: 'video'
          }
          const sourceImage = {
            image_token: ret.id,
            url: ret.cover_url,
            cover_width: ret.cover_width,
            cover_height: ret.cover_height,
            cover_size: ret.cover_size,
            type: 'video'
          }
          mater.id = df_id + id + 1
          mater.template[0].video = ret.id
          mater.template[1].cover = ret.id
          this.formItem.creativeDetails.push(...[sourceVideo, sourceImage])
          this.formItem.creatives.push(mater)
        })
      } else if (type === 'del') {
        // if (this.formItem.creatives.length === 1) {
        //   this.$Message.error('最后一个创意不能删除！')
        //   return
        // }
        const index = this.formItem.creatives.findIndex((ret) => ret.id === id)
        this.formItem.creatives.splice(index, 1)
      }
      this.verify = false
    },
    // 选中创意
    setCurrent(index) {
      this.formItem.creatives.forEach((met) => {
        this.$set(met, 'check', false)
      })
      if (typeof index === 'number' && this.formItem.creatives.length) this.$set(this.formItem.creatives[index], 'check', true)
    },
    changScene(val) {
      this.$set(this.formItem, 'scene_id', val === 1 ? [1] : [])
    },
    changeGift(val) {
      if (val) {
        this.formItem.target_action_type = this.isAndroid ? 30 : 2
        this.formItem.code = ''
      }
    },
    closeTag(name) {
      const index = this.formItem.creative_tag.findIndex((ret) => ret === name)
      if (index > -1) this.formItem.creative_tag.splice(index, 1)
    },
    selectCategroy(item) {
      this.formItem.mult_categroy = item
    },
    invalidPlus(ret, rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? ret[rule.name.split('/')[0]][rule.name.split('/')[1]] : ret[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? ret[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : ret[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isArray(param) && !param.length) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (param && rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }

      return arr
    },
    invalidExtand(ret) {
      const source = ret.creativeDetails
      const getWordKey = (key, keys) => {
        if (key && isArray(keys)) {
          const len = typeof key === 'string' ? key.length : 0
          key = key.replace(/\[|\]/g, '')
          if (keys.includes(key)) {
            return this.wordData[this.wordData.findIndex((ret) => ret.name === key)]
          } else {
            return { name: key, max_word_length: [len, len] }
          }
        } else {
          throw new Error('查找动态词位置错误')
        }
      }
      const delWord = (title) => title.replace(/\[[\u4e00-\u9fa5]{2,}\]/g, '')
      const getWords = (title) => {
        if (typeof title !== 'string' || isEmpty(title)) return
        // 正则匹配
        const matchWords = title.match(/\[[\u4e00-\u9fa5]{2,}\]/g)
        const keys = this.wordData.map((ret) => ret.name)
        if (!isArray(matchWords)) return
        return matchWords.map((key) => {
          try {
            return getWordKey(key, keys)
          } catch (err) {
            console.log(err)
          }
        })
      }
      const smartCover = Boolean(ret.smart_cover)
      return ret.creatives.map((creative) => {
        let err
        const relyon = creative.template
          .filter((met) => ['overlay_type', 'sticker_title'].includes(met.name))
          .some((met) => !isEmpty(met[met.name]))
        // 自定义创意
        if (creative.creative_material_type) {
          err = creative.template.map((met) => {
            let stat = true
            if (['image', 'video', 'cover'].includes(met.name)) {
              if (met.required && isEmpty(met[met.name])) stat = false
              // else if (['image', 'cover'].includes(met.name)) {
              else if (['image'].includes(met.name)) {
                let fileSize, Width, Height
                const { file_size, width, height } = met.restriction
                const index = source.findIndex((ret) => ret.image_token === met[met.name])
                const {
                  type,
                  file_size: realFileSize,
                  width: fileWidth,
                  height: fileHeight,
                  cover_size: coverSize,
                  cover_width: coverWidth,
                  cover_height: coverHeight
                } = source[index]
                if (type === 'video') {
                  // 默认封面
                  fileSize = coverSize
                  Width = coverWidth
                  Height = coverHeight
                } else {
                  fileSize = realFileSize
                  Width = fileWidth
                  Height = fileHeight
                }
                if (fileSize > file_size * 1024 || width !== Width || height !== Height) stat = false
                else stat = true
              } else if (met.name === 'video') {
                const { file_size, width, height } = met.restriction
                const index = source.findIndex((ret) => ret.photo_id === met[met.name])
                const { file_size: fileSize, width: Width, height: Height } = source[index]
                // if (fileSize > file_size * 1024 || Width !== width || Height !== height) stat = false
                if (fileSize > file_size * 1024) stat = false
                else stat = true
              }
            } else if (['title', 'sticker_title'].includes(met.name)) {
              let txt_length = 0
              const { min_length: min, max_length: max, text_pattern: pattern } = met.restriction
              const regx = new RegExp(pattern)

              if (['title', 'sticker_title'].includes(met.name) && met[met.name]) {
                const words = getWords(met[met.name]) // 取出所有动态词
                const data = delWord(met[met.name])
                txt_length += getByteLen(data)
                if (isArray(words)) {
                  const wordLen = words.map((ret) => ret.max_word_length).reduce((total, num) => total + num, 0)
                  txt_length += wordLen
                }
              }
              if (met.required || (relyon && met.name === 'sticker_title')) {
                stat = !isEmpty(met[met.name]) && txt_length <= max && txt_length >= min && regx.test(met[met.name])
              } else if (!isEmpty(met[met.name])) {
                stat = txt_length <= max && txt_length >= min && regx.test(met[met.name])
              } else stat = true
            } else if (['select', 'mult-select', 'overlay_type'].includes(met.name)) {
              if (met.description === '推荐理由') {
                const len = met['mult-select'].length

                if (len === 2 || len === 0) stat = true
              } else {
                if (met.required || (relyon && met.name === 'overlay_type')) stat = !isEmpty(met[met.name])
                else stat = true
              }
            }
            return stat
          })
        } else {
          const hasStickerStyle = creative.template[2].children.filter((met) => met.check).length
          err = creative.template.map((met) => {
            let stat
            if (met.name === 'action_bar') {
              if (met.required) stat = !isEmpty(met[met.name])
              else stat = true
            } else {
              let {
                required,
                restriction: { origin_template }
              } = met
              if (met.name === 'cover_slogans') required = Boolean(hasStickerStyle)

              // 20221215 去掉程序化创意这个验证
              if (met.name === 'cover_image_tokens') required = false

              if (isArray(met.children) && met.children.length === 0) {
                stat = !required
              } else if (met.name === 'photo_ids') {
                const { vertical, horizontal } = origin_template
                stat = met.children.every((m) => {
                  const type = m.name === 'horizontal' ? horizontal : vertical
                  const {
                    name,
                    required,
                    restriction: { width, height, file_size }
                  } = type
                  const index = source.findIndex((ret) => ret.photo_id === m[name])
                  const { file_size: fileSize, width: Width, height: Height } = source[index]
                  // return !((required && isEmpty(m[name])) || fileSize > file_size * 1024 || Width !== width || Height !== height)
                  return !((required && isEmpty(m[name])) || fileSize > file_size * 1024)
                })
              } else if (['cover_slogans', 'captions'].includes(met.name)) {
                const {
                  required,
                  restriction: { min_length: min, max_length: max, text_pattern }
                } = origin_template

                const regx = new RegExp(text_pattern)
                stat = met.children.every((m) => {
                  let txt_length = 0
                  const words = getWords(m[m.name]) // 取出所有动态词
                  const data = delWord(m[m.name])
                  txt_length += getByteLen(data)
                  if (isArray(words)) {
                    const wordLen = words.map((ret) => ret.max_word_length).reduce((total, num) => total + num, 0)
                    txt_length += wordLen
                  }
                  if (required) return !isEmpty(m[m.name]) && txt_length <= max && txt_length >= min && regx.test(m[m.name])
                  else if (!isEmpty(m[m.name])) return txt_length <= max && txt_length >= min && regx.test(m[m.name])
                  else return true
                })
              } else stat = true
            }

            return stat
          })
        }
        return { stat: err }
      })
    }
  },
  watch: {
    // 创意分类
    'formItem.mult_categroy': {
      handler(nVal) {
        if (nVal && nVal.length) {
          this.formItem.creative_category = nVal[0].id
        }
      },
      deep: true
    }
  }
}
